import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Link as LumxLink, Typography } from '@lumapps/lumx/react';
import { Link as RouterLink } from '@lumapps/router';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { SCOPE } from '../../constants';
import { contentTypeAdminContent } from '../../routes';

export const ContentTypeAdminContentNewPageLink: React.FC<{ uid: string }> = ({ uid }) => {
    const { get } = useDataAttributes(SCOPE);
    const { translateKey } = useTranslate();

    return (
        <LumxLink
            to={contentTypeAdminContent(uid)}
            linkAs={RouterLink}
            typography={Typography.body1}
            {...get({ element: 'link', action: 'go-to-new-page' })}
        >
            {translateKey(GLOBAL.SWITCH_TO_NEW_VIEW)}
        </LumxLink>
    );
};
